module.exports = __webpack_public_path__ + "static/media/shopping-cart.6d40947c.png";